
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"url(#pattern0_17579_4865)","d":"M0 0h18v18H0z"}}),_c('defs',[_c('pattern',{attrs:{"id":"pattern0_17579_4865","patternContentUnits":"objectBoundingBox","width":"1","height":"1"}},[_c('use',{attrs:{"xlink:href":"#image0_17579_4865","transform":"scale(.01111)"}})]),_c('image',{attrs:{"id":"image0_17579_4865","width":"90","height":"90","preserveAspectRatio":"none","xlink:href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAABhElEQVR4nO3bT07CYByE4a6EO8gRRW/pnxV6FAP7MU1YuDUZp/Nr3ucCTN9ASSjfsgAAAAAAAGCRdJT0IulD0k0+N0nvkp4lHabusZB0kvSl//e5vta0Pa7Ix9BF/b64w5Q9ztDrxzPtPGWPM/R6D0x7m7LHGfq6wYVdp+xxht7EMmQPoc0IHULoEEKHEDqE0CGEDiF0CKFDCB1C6BBChxA6hNAhhA4hdAihdxR6i0dH31P2OENXPQxV2R5n6PUfO2lPU/Y4Qx/ufyJJuUh6mLLHHfsUuriLpMdpe6zu76Tzer8yfyFdJb2uH8+/vHPa9gAAAAzTdmZEZXss2s6MqGyPK3LVmRGV7XGGrjozorI9ztBVP0uqbI8zdNWZEZXtcYbexDJkD6HNCB1C6BBChxA6hNAhhA4hdAihQwgdQugQQocQOoTQIYQOIXQIoXcUuurMiMr2OENXPQxV2R5n6KozIyrb4wxddWZEZXvcsavOjKhsj1XbmRGV7QEAAAAAAFh27AcPs/3/u7BwXwAAAABJRU5ErkJggg=="}})])])
          )
        }
      }
    